module.exports = __webpack_public_path__ + "static/img/02.5b146a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/commodity/06/02.jpg
// module id = BUv0
// module chunks = 0